module.exports = __webpack_public_path__ + "static/media/lifebuoy.e4ab879f.svg";